import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  visiblePopUp: boolean;
}

const initialState: UIState = {
  visiblePopUp: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setVisiblePopUp: (state, action: PayloadAction<boolean>) => {
      state.visiblePopUp = action.payload;
    },
  },
});

export const { setVisiblePopUp } = uiSlice.actions;
export default uiSlice.reducer;
